import routeNameDict from "./queenslandRouteNames.json";
import _ from "lodash";

export default class QueenslandRailPositionalSystem {
    static meters_per_kilometer = 1000;

    static display_formats = {
        track_kilometer_meter: "Trackcode and Kilometers",
    };

    static display_fields = {
        TRACKCODE: {
            name: "Trackcode",
            rules: [{ required: true }],
        },
        KILOMETER: {
            name: "Kilometer",
            rules: [{ required: true, type: "integer" }],
        },
        METER: {
            name: "Meter",
            rules: [{ required: true, type: "integer", min: 0, max: 999 }],
        },
    };

    lookup_route_name(routeID) {
        return _.get(routeNameDict, [routeID], routeID);
    }

    fields(display_format) {
        return QueenslandRailPositionalSystem.fields(display_format);
    }

    static fields(display_format) {
        return ["TRACKCODE", "KILOMETER", "METER"];
    }

    displayFields(display_format) {
        return QueenslandRailPositionalSystem.displayFields(display_format);
    }

    static displayFields(display_format) {
        return ["TRACKCODE", "KILOMETER", "METER"];
    }

    field_value(field, datum_offsets) {
        switch (field) {
            case "TRACKCODE":
                return this.track;
            case "KILOMETER":
                return this.kilometer;
            case "METER":
                return this.meter;
            default:
                return null;
        }
    }

    static from_fields(system_id, display_format, fields) {
        const position = fields.KILOMETER * QueenslandRailPositionalSystem.meters_per_kilometer + fields.METER;
        const route = fields.TRACKCODE.slice(0, 3);
        const subposition = fields.TRACKCODE.slice(3, 6);
        return new QueenslandRailPositionalSystem(system_id, route, position, subposition);
    }

    static from_search(system_id, fields) {
        const position = parseInt(fields.paramTwo) * QueenslandRailPositionalSystem.meters_per_kilometer + parseInt(fields.paramThree);
        const route = fields.paramOne.slice(0, 3);
        const subposition = fields.paramOne.slice(3, 6);
        return new QueenslandRailPositionalSystem(system_id, route, position, subposition);
    }

    constructor(system_id, route, position, subposition, sources) {
        this.system = system_id;
        this.route = route;
        this.track = route + subposition;
        this.position = position;
        this.subposition = subposition;
        this.sources = sources;
        this.sign = position >= 0 ? 1 : -1;
        if (this.sign < 0) {
            position = Math.abs(position);
        }
        this.kilometer = Math.floor(position / QueenslandRailPositionalSystem.meters_per_kilometer);
        this.meter = Math.floor(position - this.kilometer * QueenslandRailPositionalSystem.meters_per_kilometer);
    }

    to_string(display_format) {
        return `Trackcode: ${this.track} ${this.to_position_string()}`;
    }

    to_position_string() {
        return `${this.kilometer}km ${this.meter}m`;
    }

    to_simple_string(display_format, datum_offsets, remove_label) {
        const position = this.to_position_string();
        if (remove_label) {
            return `${position}`;
        } else {
            return `${this.route} ${position}`;
        }
    }
}
